import type { Control } from 'react-hook-form';
import { useIsFieldReadOnly } from 'src/components/form/form/customisable-form/hooks/useIsFieldReadOnly';
import { useGetThirdPartyRegister } from 'src/hooks/queries/third-party/useGetThirdPartyRegister';
import type { IssueAssessmentFields } from 'src/pages/issues/update/forms/issue-assessment-form/issueAssessmentSchema';

interface UseResponsibleThirdPartyAutosuggestArgs {
  control: Control<IssueAssessmentFields>;
  disabled?: boolean;
  name: 'ThirdPartyResponsible';
  shouldSkip: boolean;
}

export const useResponsibleThirdPartyAutosuggest = ({
  control,
  disabled,
  name,
  shouldSkip,
}: UseResponsibleThirdPartyAutosuggestArgs) => {
  const { data, loading } = useGetThirdPartyRegister({
    queryArgs: {},
    shouldSkip,
  });
  const { error } = control.getFieldState(name);
  const readOnly = useIsFieldReadOnly(name);

  return {
    props: {
      disabled: readOnly || !!disabled,
      errorText: error?.message,
      options: data?.third_party.map((thirdParty) => ({
        label: thirdParty.Title,
        value: thirdParty.Title,
      })),
      statusType: loading ? ('loading' as const) : ('finished' as const),
    },
  };
};
